'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Splash = require('@vezeeta/web-components/lib/splash/Splash');

var _Splash2 = _interopRequireDefault(_Splash);

var _reactRouterDom = require('react-router-dom');

var _webUtils = require('@vezeeta/web-utils');

var _RoleBasedAccess = require('./app/RoleBasedAccess');

var _index = require('./app/components/index');

var _logoBlue = require('./app/assets/images/logo-blue.png');

var _logoBlue2 = _interopRequireDefault(_logoBlue);

var _EnterpriseLayout = require('./EnterpriseLayout.styles');

require('./EnterpriseLayout.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EnterpriseLayout = function (_Component) {
  _inherits(EnterpriseLayout, _Component);

  function EnterpriseLayout() {
    var _temp, _this, _ret;

    _classCallCheck(this, EnterpriseLayout);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.onSignOut = function () {
      var _this$props = _this.props,
          mixpanel = _this$props.mixpanel,
          signOut = _this$props.signOut;

      mixpanel.reset();
      _webUtils.Cookie.remove(_webUtils.Cookie.LANGUAGE);
      signOut();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  EnterpriseLayout.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        language = _props.language,
        onLanguageChange = _props.onLanguageChange,
        loading = _props.loading,
        supportSingleLanguage = _props.supportSingleLanguage,
        extendContentContainer = _props.extendContentContainer,
        mixpanel = _props.mixpanel;

    if (loading) {
      return _react2.default.createElement(_Splash2.default, { logoUrl: _logoBlue2.default });
    }
    return _react2.default.createElement(
      _reactRouterDom.BrowserRouter,
      { history: this.browserhistory },
      _react2.default.createElement(
        _EnterpriseLayout.LayoutContainer,
        { language: language },
        _react2.default.createElement(_index.SideNavigation, _extends({
          onLogoClick: function onLogoClick() {
            window.location.pathname = '/';
          }
        }, this.props, this.state, {
          supportSingleLanguage: supportSingleLanguage,
          mixpanel: mixpanel,
          userRole: (0, _RoleBasedAccess.getUserRole)()
        })),
        _react2.default.createElement(_index.Header, _extends({
          onLogoClick: function onLogoClick() {
            window.location.pathname = '/';
          },
          supportSingleLanguage: supportSingleLanguage,
          onLanguageChange: onLanguageChange,
          onSignOut: this.onSignOut
        }, this.state, this.props)),
        _react2.default.createElement(
          _EnterpriseLayout.ContentContainer,
          { extendContentContainer: extendContentContainer },
          children
        )
      )
    );
  };

  return EnterpriseLayout;
}(_react.Component);

EnterpriseLayout.propTypes = process.env.NODE_ENV !== "production" ? {
  loading: _propTypes2.default.bool.isRequired,
  children: _propTypes2.default.any.isRequired,
  language: _propTypes2.default.string.isRequired,
  onLanguageChange: _propTypes2.default.func.isRequired,
  mixpanel: _propTypes2.default.object.isRequired,
  signOut: _propTypes2.default.func.isRequired,
  supportSingleLanguage: _propTypes2.default.bool,
  extendContentContainer: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array])
} : {};

exports.default = EnterpriseLayout;
module.exports = exports['default'];